/**
 * 商品階層API
 * 商品階層の情報を取得
 */

import { apiGet } from './client';
import type { ProductGroupTree, ProductGroupTreeExtended } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { ProductGroupTree, ProductGroupTreeExtended } from '@/lib/types';

/**
 * 商品階層一覧を取得（拡張版 - リレーションデータを含む）
 */
export async function getProductGroupTreesExtended(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<ProductGroupTreeExtended[]> {
  return apiGet<ProductGroupTreeExtended[]>(
    `/${accountCode}/product-group-trees/extended`,
    authHeaders,
  );
}

/**
 * 商品階層一覧を取得（既存 - 後方互換性のため保持）
 */
export async function getProductGroupTrees(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<ProductGroupTree[]> {
  return apiGet<ProductGroupTree[]>(`/${accountCode}/product-group-trees`, authHeaders);
}
